import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SecurityRequestService } from './security-request.service';
import { map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PedidoService {

  public carregarPainel = new EventEmitter<string>();

  constructor(
    private securityRequestService: SecurityRequestService,
    private authService: AuthService,
    private httpClient: HttpClient
  ) { }

  getList(parameters: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/Pedido/lista`, parameters);
  }

  public get(id: string): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/pedido/${id}`);
  }

  public getByNumero(numero: number, ano: number): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/pedido/numero/${numero}/ano/${ano}`);
  }

  public getByNumeroOuNumeroSiscort(numero: number, ano: number, numeroSiscort: number): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/pedido/numero/${numero}/ano/${ano}/siscort/${numeroSiscort}`);
  }

  public post(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido`, data);
  }

  public postV2(numeroDoPedido: number, ano: number): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/pedido/V2/pedido/${numeroDoPedido}/ano/${ano}`);
  }

  public delete(id: any): Observable<any> {
    return this.securityRequestService.delete(`${environment.bffApi}/pedido/${id}`);
  }

  public sendMail(destinatarios: string, idPedido: string, idCliente: string): Observable<any> {
    let _body = {
      EmailsDestinatarios: destinatarios,
      IdPedido: idPedido,
      IdCliente: idCliente
    };

    return this.securityRequestService.post(`${environment.bffApi}/pedido/enviar-email`, _body);
  }

  public addItemTabela(pedido: any, item: any): Observable<any> {

    let body = {
      Pedido: pedido,
      Item: item
    };

    return this.securityRequestService.post(`${environment.bffApi}/pedido/Item/Tabela/Add`, body);
  }

  public alterItem(pedido: any, item: any): Observable<any> {

    let body = {
      Pedido: pedido,
      Item: item
    };

    return this.securityRequestService.post(`${environment.bffApi}/pedido/Item/Alter`, body);
  }

  public calcularImpostos(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/CalcularImpostos`, data);
  }

  public editarItensEmLote(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/EditarItensEmLote`, data);
  }

  public EDI(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/EDI`, data);
  }

  public contrato(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/contrato`, data);
  }

  public getCarteiraDoPedido(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/carteira`, data);
  }

  public getItensDaCarteiraDoPedido(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/carteira-itens`, data);
  }

  public getPedidosAprovadosME(data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/relatorio-pedidos-me`, data);
  }

  public aprovar(pedido: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/aprovarV2`, pedido);
    // return this.securityRequestService.post(`${environment.bffApi}/pedido/aprovar`, pedido);
  }

  public desbloquearLista(ids: string[]): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/Pedido/desbloquear/lista`, ids);
  }

  public getBloqueioByIdPedido(idPedido: string): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/Pedido/bloqueio/pedido/${idPedido}`);
  }

  importarEDI(idEmpresa: string, dataDoRecebimento: string, idCliente: string | null, data: any): Observable<any> {
    return this.securityRequestService.post(
      `${environment.bffApi}/Pedido/empresa/${idEmpresa}/cliente/${idCliente}/dataDoRecebimento/${dataDoRecebimento}/importar-edi`,
      data);
  }
  importarPlanilha(idEmpresa: string, dataDoRecebimento: any, idCliente: string, data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/Pedido/empresa/${idEmpresa}/data-do-recebimento/${dataDoRecebimento}/cliente/${idCliente}/importar-planilha`, data);
  }
  importarPlanilhaTransferencia(idEmpresaOrigem: string, idEmpresDestino: any, dataDoRecebimento: any, data: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/Pedido/empresa-origem/${idEmpresaOrigem}/empresa-destino/${idEmpresDestino}/data-do-recebimento/${dataDoRecebimento}/importar-planilha-transferencia`, data);
  }
  public new(): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/pedido/new`);
  }

  public addEmpresa(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      EmpresaId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/Empresa/Add`, body);
  }

  public addCliente(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ClienteId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/Cliente/Add`, body);
  }

  public removeItem(pedido: any, item: any): Observable<any> {

    let body = {
      Pedido: pedido,
      Item: item
    };

    return this.securityRequestService.post(`${environment.bffApi}/pedido/Item/Remove`, body);
  }

  public addItemsContract(pedido: any, data: any): Observable<any> {

    let body = {
      Pedido: pedido,
      Data: data
    };

    return this.securityRequestService.post(`${environment.bffApi}/pedido/Contrato/addItems`, body);
  }

  public duplicar(data: any): Observable<any> {

    return this.securityRequestService.post(`${environment.bffApi}/pedido/Duplicar`, data);
  }

  public addClienteVendaAOrdem(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ClienteId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/Cliente/VendaAOrdem/Add`, body);
  }

  public addTransportadoraVendaAOrdem(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ClienteId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/Transportadora/VendaAOrdem/Add`, body);
  }

  public addTransportadora(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ClienteId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/Transportadora/Add`, body);
  }

  public addTransportadoraRedespacho(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ClienteId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/Transportadora/Redespacho/Add`, body);
  }

  public addDespesa(pedido: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/despesas/add`, pedido);
  }

  public updateIncoterm(pedido: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/incoterm/update`, pedido);
  }

  public removeDespesa(pedido: any, despesa): Observable<any> {
    let body = {
      Pedido: pedido,
      Despesa: despesa
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/despesas/remove`, body);
  }

  public addContato(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ContatoId: id
    }
    return this.securityRequestService.post(`${environment.bffApi}/pedido/contato/Add`, body);
  }

  public removeContato(pedido: any, id: string): Observable<any> {
    let body = {
      Pedido: pedido,
      ContatoId: id
    }
    return this.securityRequestService.remove(`${environment.bffApi}/pedido/contato/Remove`, body);
  }

  public addFollowUp(pedido: any, followUp): Observable<any> {
    let body = {
      Pedido: pedido,
      followUp: followUp
    }

    return this.securityRequestService.post(`${environment.bffApi}/pedido/followup/add`, body);
  }

  public getTotalPorMes(mercado: string, empresa: string, status: string, mes: string, visibilidade: string): Observable<any> {
    var _statusCode = this.getCodStatus(status);
    return this.securityRequestService.get(`${environment.bffApi}/Pedido/TotalPorMes/mercado/${mercado}/empresa/${empresa}/visibility/${visibilidade}/status/${_statusCode}/mes/${mes}`);
  }

  public getTotalPorStatus(mercado: string, empresa: string, status: string, visibilidade: string): Observable<any> {
    var _statusCode = this.getCodStatus(status);
    return this.securityRequestService.get(`${environment.bffApi}/Pedido/TotalPorStatus/mercado/${mercado}/empresa/${empresa}/visibility/${visibilidade}/status/${_statusCode}`);
  }

  public getImpressao(idPedido: string, itensPorPagina: number, language: string): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/Pedido/${idPedido}/impressao/itensporpagina/${itensPorPagina}/language/${language}`);
  }

  public getImpressaoV2(idPedido: string, language: string, vendedorExterno: any, vendedorInterno: any, gerente: any): Observable<any> {
    let body = {
      IdDocumento: idPedido,
      language: language,
      VendedorExterno: vendedorExterno,
      VendedorInterno: vendedorInterno,
      Gerente: gerente
    }
    return of({})
      .pipe(
        switchMap(request => this.authService.AcquireTokenSilent()),
        map(request => {
          return Object.assign({}, { responseType: 'blob' as 'json' }, {
            headers: new HttpHeaders().set('Authorization', `Bearer ${request.accessToken}`)
          });
        }),
        switchMap(options1 => this.httpClient.post(`${environment.bffApi}/Pedido/Impressaov2`, body, options1)),
        map((response: any) => {
          let dataType = response.type;
          let binaryData = [];
          binaryData.push(response);
          let downloadLink = document.createElement('a');
          downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
          downloadLink.setAttribute('download', "Pedido ME");
          document.body.appendChild(downloadLink);
          window.open(downloadLink.href, "Pedido ME");
        }),
      )
  }

  public ordenarItens(itens: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/Pedido/Item/Ordenar`, itens);
  }

  public getMercadoExternoNaoFaturado(idCliente: number, idEmpresa: string, idsPedidosJaAdicionados: any): Observable<any> {
    let _body = {
      IdCliente: idCliente,
      IdEmpresa: idEmpresa,
      IdsPedidosJaAdicionados: idsPedidosJaAdicionados
    };

    return this.securityRequestService.post(`${environment.bffApi}/Pedido/mercado-externo`, _body);
  }

  public sendBusSiscort(idPedido: string): Observable<any> {
    return this.securityRequestService.get(`${environment.bffApi}/Pedido/sendbus/${idPedido}`);
  }

  public updateMarcas(pedido: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/Pedido/AtualizarMarca`, pedido);
  }

  public estimarEmbalagens(pedido: any): Observable<any> {
    return this.securityRequestService.post(`${environment.bffApi}/pedido/embalagens/estimar`, pedido);
  }
  public removeEmbalagem(pedido: any, embalagem: number): Observable<any> {

    let body = {
      Pedido: pedido,
      NumeroDaEmbalagem: embalagem
    }

    return this.securityRequestService.post(`${environment.bffApi}/pedido/embalagens/remove`, body);
  }

  public updateEmbalagem(pedido: any, embalagem: number): Observable<any> {

    let body = {
      Pedido: pedido,
      Embalagem: embalagem
    }

    return this.securityRequestService.post(`${environment.bffApi}/pedido/embalagens/update`, body);
  }

  getCodStatus(status: string): string {
    switch (status) {
      case "aprovado":
        return "1";
      case "parcialmenteaprovado":
        return "7";
      case "bloqueado":
        return "2";
      case "cancelado":
        return "6";
      case "devolvido":
        return "5";
      case "excluido":
        return "3";
      case "rascunho":
        return "4";
      default:
        return "all";
    }
  }
}
